export class CplChangeUserRequestManager {
    ManagingUserID: string;
    UserRequestID: string;

    constructor(ManagingUserID: string, UserRequestID: string) {
        this.ManagingUserID = ManagingUserID;
        this.UserRequestID = UserRequestID;
    }
}